import { EmployerBillingScheduleTypeEnum, EmployerStatusEnum, EmployerStatusFormEnum } from '../../../core/enums/benefit/employer';

export const getEmployerStatus = (status) => {
    switch (status) {
        case EmployerStatusEnum.ACTIVE:
            return 'Aktywny';
        case EmployerStatusEnum.INACTIVE:
            return 'Nieaktywny';
        default:
            return EmployerStatusEnum.UNKNOWN;
    }
};

export const getEmployerBillingScheduleType = (type) => {
    switch (type) {
        case EmployerBillingScheduleTypeEnum.WEEKLY.value:
            return EmployerBillingScheduleTypeEnum.WEEKLY.label;
        case EmployerBillingScheduleTypeEnum.BIWEEKLY.value:
            return EmployerBillingScheduleTypeEnum.BIWEEKLY.label;
        case EmployerBillingScheduleTypeEnum.MONTHLY.value:
            return EmployerBillingScheduleTypeEnum.MONTHLY.label;
        default:
            return EmployerBillingScheduleTypeEnum.NONE.label;
    }
};

export const getButtonText = (status) => {
    switch (status) {
        case EmployerStatusEnum.ACTIVE:
            return 'Dezaktywuj';
        case EmployerStatusEnum.INACTIVE:
            return 'Aktywuj';
        default:
            return EmployerStatusEnum.UNKNOWN;
    }
};

export const getUpdateEmployerStatus = (status) => {
    switch (status) {
        case EmployerStatusEnum.ACTIVE:
            return EmployerStatusFormEnum.DEACTIVATE;
        case EmployerStatusEnum.INACTIVE:
            return EmployerStatusFormEnum.ACTIVATE;
        default:
            return EmployerStatusEnum.UNKNOWN;
    }
};

export const getEmployerBillingScheduleTypeOptions = [
    { value: EmployerBillingScheduleTypeEnum.WEEKLY.value, label: EmployerBillingScheduleTypeEnum.WEEKLY.label },
    { value: EmployerBillingScheduleTypeEnum.BIWEEKLY.value, label: EmployerBillingScheduleTypeEnum.BIWEEKLY.label },
    { value: EmployerBillingScheduleTypeEnum.MONTHLY.value, label: EmployerBillingScheduleTypeEnum.MONTHLY.label },
    { value: EmployerBillingScheduleTypeEnum.NONE.value, label: EmployerBillingScheduleTypeEnum.NONE.label }
];
